/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', '$uibModalInstance', 'DataUtils', 'entity', 'ProjectBoard', 'PrincipalProfile', '$http', 'Principal'];

    function ProjectDialogController ($timeout, $scope, $stateParams ,$q, $uibModalInstance, DataUtils, entity, ProjectBoard, PrincipalProfile, $http, Principal) {
        var vm = this;

        vm.project = entity;
        vm.isBoard = false;

        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.isInstructorProject = false;
        vm.isBoatProject = false;
        vm.wasActive = vm.project.active;
        vm.wasVisible = vm.project.visible;

        if (vm.wasActive || vm.wasVisible) {
            if (vm.project.authorizedGroupsString.includes('ROLE_INSTRUCTOR')) {
                Principal.hasAuthority('ROLE_INSTRUCTOR').then(function (result) {
                    vm.isInstructorProject = result;
                });
            }
            if (vm.project.authorizedGroupsString.includes('ROLE_BOAT')) {
                Principal.hasAuthority('ROLE_BOAT').then(function (result) {
                    vm.isBoatProject = result;
                });
            }
        }

        vm.authorities = [
            'ROLE_INSTRUCTOR',
            'ROLE_BOAT',
            'ROLE_SKS_PLUS',
            'ROLE_SKIPPER',
            'ROLE_SKIPPER_CANDIDATE',
            'ROLE_SKIPPER_ASKEW',
            'ROLE_SAILOR_COUNCIL',
            'ROLE_DINGHY',
            'ROLE_UNIVERSITY_GROUP'
        ];
        vm.newType = $stateParams.type;
        if (entity.id == null && vm.newType !== null) {
            PrincipalProfile.identity().then(function(profile) {
                vm.project.profile = profile;
            });
            if (vm.newType === 'boat') {
                vm.project.authorizedGroupsString = [vm.authorities[1]];
            }
            else if (vm.newType === 'instructor') {
                vm.project.authorizedGroupsString = [vm.authorities[0]];
            }
            else if (vm.newType === 'boatInstructor') {
                vm.project.authorizedGroupsString = [vm.authorities[0], vm.authorities[1]];
            }
        }
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.getUser = getUser;
        vm.getProject = getProject;
        vm.replaceYear = replaceYear;
        vm.selectFromDate = selectFromDate;
        vm.resetGuestPrice = resetGuestPrice;
        vm.disableFilter = false;

         function selectFromDate () {
            $scope.options = {
                minDate: new Date(vm.project.fromDate),
                initDate: new Date(vm.project.fromDate)
            };
            vm.replaceYear();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.project.dependingProject === "") {
                vm.project.dependingProject = null;
            }

            if (vm.project.id !== null) {
                if (vm.project.closed) {
                    vm.project.active = false;
                    vm.project.visible = false;
                }
                ProjectBoard.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                if (vm.project.type === 'interest') {
                    vm.project.identifier = "interest";
                    vm.project.normalPrice = 0;
                    vm.project.studentPrice = 0;
                }
                if (vm.project.type !== 'sbfPractical') {
                    vm.project.sbfSlotsMax = null;
                }
                ProjectBoard.save(vm.project, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        vm.setImage = function ($file, project) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if($file) {
                createImage(URL.createObjectURL($file)).then(function(image) {
                    var file = resize(image, $file.type).split(',');
                    project.image = file[1];
                    project.imageContentType = $file.type;
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        var createImage = function(src) {
            var defer = $q.defer();
            var img = new Image();
            img.onload = function() {
                defer.resolve(img);
            };
            img.src = src;
            return defer.promise;
        };

        var resize = function(image, type) {
            var mainCanvas;
            mainCanvas = document.createElement("canvas");

            var ratioX = 1000 / image.width;
            var ratioY = 1000 / image.height;
            var ratio = Math.min(ratioX, ratioY);

            var newWidth = image.width * ratio;
            var newHeight = image.height * ratio;

            mainCanvas.width = newWidth;
            mainCanvas.height = newHeight;
            var ctx = mainCanvas.getContext("2d");
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            return mainCanvas.toDataURL(type);
        };

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function getProject(val) {
            return $http.get('api/_search/projectsnotclosed/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function replaceYear() {
            var replaceYear = vm.project.fromDate.getFullYear();
            var replaceYearTwoDigit = replaceYear.toString().substr(-2);
            vm.project.identifier = vm.project.identifier.replace(replaceYear, '').replace(replaceYearTwoDigit, '');
        }

        function resetGuestPrice() {
            vm.project.guestPrice = null;
        }

        $http.get('api/board/profiles/manager/').then(function(response) {
            vm.allManagers = response.data;
        });
    }
})();
